import { Grid } from '@mui/material';
import { ColorPickerColors } from '../../../../models/ColorPicker';
import ColorPicker from '../../../Pickers/ColorPicker/ColorPicker';

interface ButtonColorPickerProps {
  value?: string | ColorPickerColors;
  onChangeColor?: (value: string | ColorPickerColors) => void;
}

const ButtonColorPicker = ({ value, onChangeColor }: ButtonColorPickerProps) => (
  <Grid container alignItems="center" justifyContent="center" spacing={2}>
    <Grid item>
      色
    </Grid>
    <Grid item>
      <ColorPicker value={value} onPickColor={onChangeColor} />
    </Grid>
  </Grid>
);

export default ButtonColorPicker;
